"use strict";

import * as THREE from "three";

const LanceLeafCoreopsisHub: ShootPreset = {
    id: "LanceLeafCoreopsisHub",
    shootCount: 1,

    maxWidth: .35,
    maxHeight: .35,

    lengthSegments: 4,
    widthSegments: 6,

    materialPreset: {
        shootTextureIndex: 17,
        uniforms: {
            shootTextureColorA: { value: new THREE.Color(0.84, 0.58, 0.03) },
            shootTextureColorB: { value: new THREE.Color(0.59, 0.23, 0) },
        },
    },

    pathFunction() {
        let points = [new THREE.Vector3(0, 0, 0), new THREE.Vector3(0, .2, 0)];
        return new THREE.CatmullRomCurve3(points);
    },

    getNormalOffset(lengthProgress, widthProgress) {
        return Math.sin(widthProgress * Math.PI) * Math.sqrt(1 - Math.pow((1 - lengthProgress) - 1, 2));
    },

    getBinormalOffset(lengthProgress, widthProgress) {
        return Math.cos(widthProgress * Math.PI) * Math.sqrt(1 - Math.pow((1 - lengthProgress) - 1, 2));
    },


    transformInstance(i) {
        return new THREE.Matrix4();
    }
}

const LanceLeafCoreopsisPetal: ShootPreset = {
    id: "LanceLeafCoreopsisPetal",
    shootCount: 8,

    maxWidth: .45,
    maxHeight: .1,
    maxLength: .45,

    lengthSegments: 12,
    widthSegments: 6,

    materialPreset: {
        shootTextureIndex: 9,
        uniforms: {
            shootTextureColorA: { value: new THREE.Color(1, 0.85, 0.14) },
            shootTextureColorB: { value: new THREE.Color(0.86, 0.58, 0) },
        },
    },

    pathFunction: () => {

        let points = [
            new THREE.Vector3(.25, 0, 0),
            new THREE.Vector3(1.5, .5, 0),
        ];

        let path = new THREE.CatmullRomCurve3(
            points, false, "catmullrom", .5
        );

        return path;
    },

    getBinormalOffset: (lengthProgress, widthProgress) => {
        let height = Math.sin((widthProgress / 2) * (Math.PI)) * widthProgress;
        height *= Math.sin((1 - lengthProgress) * Math.PI);

        return height;
    },

    getNormalOffset: (lengthProgress, widthProgress) => {
        if (lengthProgress < .5) {
            return Math.pow(lengthProgress + .5, 1.75) * widthProgress;
        } else {
            return widthProgress;
        }
    },

    getTangentOffset: (lengthProgress, widthProgress) => {
        return lengthProgress * ((Math.sin(widthProgress * Math.PI * 2.5) + 1) / 2) * (1 - widthProgress);
    }
}

export const LanceLeafCoreopsis: BloomPreset = {
    bounds: 1.75,
    shootPresets: [LanceLeafCoreopsisPetal, LanceLeafCoreopsisHub],
}